import { Form, Formik } from 'formik'
import React from 'react'
import { useAuthMutation } from '../../queries/users'
import { LaserScannerForm } from 'src/pages/qr-scanner/qr-scanner'
import { Element, Heading, Icon, Loader } from 'react-bulma-components'
import { QrcodeIcon } from '@heroicons/react/outline'

interface LoginFormProps {
  loginAsQrScannerForEmployerId?: string
}

const QrLoginForm: React.FC<LoginFormProps> = ({ loginAsQrScannerForEmployerId }) => {
  const authMutation = useAuthMutation()

  const laserScannerInitialValues = {
    qr: '',
  }

  return (
    <>
      <Formik
        initialValues={laserScannerInitialValues}
        onSubmit={async (values, { resetForm }) => {
          if (values.qr) {
            try {
              const hash = JSON.parse(values.qr)
              if (hash.content && hash.iv) {
                authMutation.mutate({
                  qr: JSON.parse(values.qr),
                  loginAsQrScannerForEmployerId,
                })
              }
            } catch (err) {
              console.error(err)
            }
            resetForm({
              values: { qr: '' },
            })
          }
        }}
      >
        {props => {
          return (
            <Form>
              <Element textAlign={'center'}>
                <Icon size={'large'}>
                  <QrcodeIcon />
                </Icon>
                <Heading size={6}>Scannez votre QR</Heading>
                <LaserScannerForm formikProps={props} />
                <Loader display="inline-block" />
              </Element>
            </Form>
          )
        }}
      </Formik>
    </>
  )
}

export default QrLoginForm
